module.exports = __webpack_public_path__ + "img/room_set.e2977a7e.png";